import { Routes, Route, useOutletContext } from "react-router-dom";
import { AddTeam } from "../Pages/Private/Settings/Information/Team/AddTeam";
import SocioProTab from "../Pages/Private/Settings/SocioPro/SocioProTab";
import AddSocioPro from "../Pages/Private/Settings/SocioPro/AddSocioPro";
import AddHoursType from "../Pages/Private/Settings/TimeManagement/Form/AddHoursType";
import AddCounter from "../Pages/Private/Settings/Counters/AddCounter";
import AddWorkShift from "../Pages/Private/Settings/TimeManagement/Form/AddWorkShift";
import AddDayModel from "../Pages/Private/Settings/TimeManagement/Form/AddDayModel";
import Establishment from "../Pages/Private/Settings/Information/Establishment";
import AddEstablishment from "../Pages/Private/Settings/Information/AddEstablishment";
import { Subscription } from "../Pages/Private/Settings/Subscription";
// import TimeManagement from "../Pages/Private/Settings/TimeManagement/TimeManagement";
import TimeManagementTab from "../Pages/Private/Settings/TimeManagement/TimeManagement";
import CompanyParametrageTab from "../Pages/Private/Settings/CompanyParametrageTab";
import Counters from "../Pages/Private/Settings/Counters/Counters";
import { RightsManagement } from "../Pages/Private/Settings/RightsManagement/RightsManagement";
import { RightsProfile } from "../Pages/Private/Settings/RightsManagement/RightsProfile";
import Badgeuse from "../Pages/Private/Settings/Information/Badgeuse/Badgeuse";
import { InformationTab } from "../Pages/Private/Settings/Information/InformationTab";
import { AddBadgeuse } from "../Pages/Private/Settings/Information/Badgeuse/AddBadgeuse";
import { AddProject } from "../Pages/Private/Settings/Information/Project/AddProject";
import { Project } from "../Pages/Private/Settings/Information/Project/Project";
import { Team } from "../Pages/Private/Settings/Information/Team/Team";
import Settings from "../Pages/Private/Settings/Settings";
import { Bibliothèque } from "../Pages/Private/Manifestation/Bibliothèque";
import { ExportView } from "../Pages/Private/Settings/ExportView";
import { ExportProfileForm } from "../Pages/Private/Settings/Export/ExportProfileForm";

export const CompanyRouter = () => {
    const [user, setUser] = useOutletContext();

    return (
        <Routes>
            <Route
                path="/abonnement"
                element={<Subscription isInContext={true} />}
            />
            <Route path="/profil" element={<RightsManagement />} />
            <Route path="/exports" element={<ExportView />} />
            <Route path="/exports/profiles/add" element={<ExportProfileForm />} />
            <Route path="/exports/profiles/edit/:profile_id" element={<ExportProfileForm />} />

            <Route path="/profil/add" element={<RightsProfile />} />
            <Route path="/profil/edit/:right_id" element={<RightsProfile />} />

            <Route path="/bibliotheque" element={<Bibliothèque />} />
            <Route
                path="/"
                element={<Settings user={user} setUser={setUser} />}
            >
                <Route path="/informations" element={<InformationTab />} />

                {/* Catégories socio pro */}
                <Route
                    path="/socio-professional/:category_id"
                    element={<AddSocioPro />}
                />
                <Route path="/socio-professional" element={<SocioProTab />} />
                <Route
                    path="/socio-professional/create"
                    element={<AddSocioPro />}
                />

                {/* TYPES D'HEURES */}
                <Route path="/hours/create" element={<AddHoursType />} />
                <Route path="/hours/:ht_id" element={<AddHoursType />} />

                {/* ESTABLISHMENT */}
                <Route
                    path="/establishment/:establishment_id/update"
                    element={<AddEstablishment />}
                />
                <Route
                    path="/establishment/create"
                    element={<AddEstablishment />}
                />
                <Route
                    path="/establishments/:establishment_id"
                    element={<Establishment />}
                />
                <Route
                    path="/establishments/:establishment_id/project/new"
                    element={<AddProject />}
                />
                <Route
                    path="/establishments/:establishment_id/project/:project_id"
                    element={<Project />}
                />
                <Route
                    path="/establishments/:establishment_id/team/new"
                    element={<AddTeam />}
                />
                <Route
                    path="/establishments/:establishment_id/team/:team_id"
                    element={<Team />}
                />
                {/* BADGEUSE */}
                <Route
                    path="/establishments/:establishment_id/badgeuse/new"
                    element={<AddBadgeuse />}
                />
                <Route
                    path="/establishments/badgeuses/:badgeuse_id"
                    element={<Badgeuse />}
                />
                {/* Compteurs */}
                <Route path="/counter/:counter_id" element={<AddCounter />} />
                <Route path="/counter/create" element={<AddCounter />} />
                <Route path="/counters" element={<Counters />} />

                {/* Cycles de travail */}
                <Route path="/workshift/:ws_id" element={<AddWorkShift />} />
                <Route path="/workshift/create" element={<AddWorkShift />} />

                {/* Modèles de journée */}
                <Route path="/daymodel/:dm_id" element={<AddDayModel />} />
                <Route path="/daymodel/create" element={<AddDayModel />} />
                {/* Time management */}
                <Route path="/time" element={<TimeManagementTab />} />
                <Route path="/settings" element={<CompanyParametrageTab />} />
            </Route>
        </Routes>
    );
};
